import pdfButton from "../media/orange-PDF.svg";
import docButton from "../media/doc-orange.svg";
import jpgPhotoButton from "../media/jpg-photo.svg";
import txtButton from "../media/txt-orange.svg";
import zipButton from "../media/zip.svg";
import xlsButton from "../media/xls-orange.svg";

export const getIconForSingleFile = (iconName) => {
  switch (iconName) {
    case "docButton":
      return docButton;
    case "zipButton":
      return zipButton;
    case "jpgPhotoButton":
      return jpgPhotoButton;
    case "pdfButton":
      return pdfButton;
    case "xlsButton":
      return xlsButton;
    case "txtButton":
      return txtButton;
    default:
      return txtButton;
  }
};
